import { render, staticRenderFns } from "./assignPromoter.vue?vue&type=template&id=7a889b6b&scoped=true"
import script from "./assignPromoter.vue?vue&type=script&lang=js"
export * from "./assignPromoter.vue?vue&type=script&lang=js"
import style0 from "./assignPromoter.vue?vue&type=style&index=0&id=7a889b6b&prod&lang=scss&scoped=true"
import style1 from "./assignPromoter.vue?vue&type=style&index=1&id=7a889b6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a889b6b",
  null
  
)

export default component.exports